import React from "react";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import ExplorePage from "./pages/ExplorePage";
import JourneyPage from "./pages/JourneyPage";
import Skills from "./pages/Skills";
import Cases from "./pages/Cases";
import BlogHome from "./pages/BlogHome";
import BlogDetail from "./pages/BlogDetail";
import WorkWithMe from './pages/WorkWithme';
import ContractTips from "./pages/ContractTips";
import ContractTipDetail from "./pages/ContractTipDetail";
import ContractCompass from "./pages/ContractCompass";
import PodcastPage from "./pages/PodcastPage";
import Admin from "./pages/Admin";
import KnowMe from "./pages/KnowMe";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Sitemap from "./pages/Sitemap";
import GuidancePage from "./pages/GuidancePage";
import GuidanceRespond from "./pages/GuidanceRespond";
import GuidanceReflection from "./pages/GuidanceReflection";
import SubscriptionStatus from "./pages/SubscriptionStatus";
import DeskAuth from "./pages/DeskAuth";
import DeskDashboard from "./pages/DeskDashboard";
import DeskContractDetail from "./pages/DeskContractDetail";
import ScrollToTop from "./ScrollToTop";
import CookieBanner from "./components/CookieBanner";
import CoinFlipTransition from "./components/CoinFlipTransition";
import AskNaga from "./components/AskNaga";

function App() {

  return (
    <HelmetProvider>
    <Router>
      <ScrollToTop />
      <CookieBanner />
      <CoinFlipTransition />
      <AskNaga />
      <Routes>
        {/* Main */}
        <Route path="/" element={<Home />} />

        {/* Explore Section Pages */}
        <Route path="/explore" element={<ExplorePage />} />
        <Route path="/journey" element={<JourneyPage />} />
        <Route path="/skills" element={<Skills />} />
        <Route path="/know-me" element={<KnowMe />} />
        <Route path="/cases" element={<Cases />} />

        {/* Blog - The PP Edit */}
        <Route path="/blog" element={<BlogHome />} />
        <Route path="/blog/:slug" element={<BlogDetail />} />
        <Route path="/work-with-me" element={<WorkWithMe />} />
        <Route path="/podcast" element={<PodcastPage />} />
        <Route path="/contract-tips" element={<ContractTips />} />
        <Route path="/contract-tips/:slug" element={<ContractTipDetail />} />
        <Route path="/contract-compass" element={<ContractCompass />} />

        {/* Guidance */}
        <Route path="/guidance" element={<GuidancePage />} />
        <Route path="/guidance/respond" element={<GuidanceRespond />} />
        <Route path="/guidance/reflection" element={<GuidanceReflection />} />

        {/* Newsletter subscribe confirm/unsubscribe landing pages */}
        <Route path="/subscribed" element={<SubscriptionStatus mode="subscribed" />} />
        <Route path="/unsubscribed" element={<SubscriptionStatus mode="unsubscribed" />} />

        {/* Contract Desk — paid, persistent contract workspaces */}
        <Route path="/desk/login" element={<DeskAuth mode="login" />} />
        <Route path="/desk/signup" element={<DeskAuth mode="signup" />} />
        <Route path="/desk" element={<DeskDashboard />} />
        <Route path="/desk/contracts/:id" element={<DeskContractDetail />} />

        {/* Admin */}
        <Route path="/admin" element={<Admin />} />

        {/* Legal */}
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/sitemap" element={<Sitemap />} />
      </Routes>
    </Router>
    </HelmetProvider>
  );
}

export default App;
